import { API_URL } from "../config/connect";

const getAnnouncementsAnalytics = async (period = "30d") => {
    const endpoint = `${API_URL}/api/v1/analytics/announcements?period=${encodeURIComponent(period)}`;
    const googleIdToken = localStorage.getItem("google_id_token");
    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${googleIdToken}`,
                "Content-Type": "application/json",
            }
        });

        if (!response.ok) {
            const err = new Error(`Network response was not ok: ${response.status}`);
            err.status = response.status;
            throw err;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('There was a problem fetching the announcements analytics:', error);
        throw error;
    }
};

export default getAnnouncementsAnalytics;
